import axios from "axios";
import { saveAs } from 'file-saver'
import { blobValidate } from "@/utils/heimao";
import { getToken } from '@/utils/auth'
const baseURL = process.env.BASE_API
export default {
  saveAs(text, name, opts) {
    saveAs(text, name, opts);
  },
  zip(url, name) {
    var url = baseURL + url
    axios({
      method: 'get',
      url: url,
      responseType: 'blob',
      headers: { 'Authorization': 'Bearer ' + getToken() }
    }).then(async (res) => {
      const isLogin = await blobValidate(res.data);
      if (isLogin) {
        const blob = new Blob([res.data], { type: 'application/zip' })
        this.saveAs(blob, name)
      }
      // else {
      //   // this.printErrMsg(res.data);
      // }
    })
  },
}



// WEBPACK FOOTER //
// ./src/utils/download.js